export const PROCESS_ORDER_ERROR = 'PROCESS_ORDER_ERROR';
export const PROCESS_ORDER_LOADING = 'PROCESS_ORDER_LOADING';
export const PROCESSED_ORDER_PREVIEW_DATA = 'PROCESSED_ORDER_PREVIEW_DATA';
export const CREATE_PO_WO_BO_LOADING = 'CREATE_PO_WO_BO_LOADING';
export const CREATE_PO_WO_BO__ERROR = 'CREATE_PO_WO_BO__ERROR';
export const SET_PROCESS_ID = 'SET_PROCESS_ID';
export const FETCH_PREVIEW_ORDER_LOADING = 'FETCH_PREVIEW_ORDER_LOADING';
export const FETCH_PREVIEW_ORDER_ERROR = 'FETCH_PREVIEW_ORDER_ERROR';
export const CLEAR_PREVIEW_ORDER_ERROR = 'CLEAR_PREVIEW_ORDER_ERROR';
export const PRINT_PREVIEW_ERROR = 'PRINT_PREVIEW_ERROR';
export const PRINT_PREVIEW_LOADING = 'PRINT_PREVIEW_LOADING';
export const PRINT_VENDOR_SUMMARY_ERROR = 'PRINT_VENDOR_SUMMARY_ERROR';
export const PRINT_VENDOR_SUMMARY_LOADING = 'PRINT_VENDOR_SUMMARY_LOADING';
export const PRINT_VENDOR_SUMMARY_DATA = 'PRINT_VENDOR_SUMMARY_DATA';
export const CLEAR_PRINT_VENDOR_SUMMARY_DATA =
  'CLEAR_PRINT_VENDOR_SUMMARY_DATA';
export const PRINT_PREVIEW_DATA = 'PRINT_PREVIEW_DATA';
export const CLEAR_PRINT_PREVIEW_DATA = 'CLEAR_PRINT_PREVIEW_DATA';
export const SET_PROCESS_MESSAGE_ERROR = 'SET_PROCESS_MESSAGE_ERROR';
export const CLEAR_PROCESS_MESSAGE = 'CLEAR_PROCESS_MESSAGE';


// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/processOrder/types.js